<div class="remove-dialog">
  <div class="warning-badge-remove" style="justify-self: center; padding-top: 3px">
    <span
      inlineSVG="assets/media/svg/icons/General/alert.svg"
      class="ks-text-warning svg-icon svg-icon-3x"
    ></span>
  </div>
  <h3 class="dialog-title ks-font-size-lg ks-mb-3">Select a new primary payment method</h3>
  <p class="ks-text-neutral ks-font-size-sm ks-text-center ks-mb-10">
    You need to choose a new primary payment method before deleting this one.
  </p>

  <fieldset class="ks-checkboxes-wrapper ks-px-15 ks-pt-3 ks-pb-6 ks-mb-10">
    <kt-checkbox
      *ngFor="let card of notDefaultCards"
      [isRadio]="true"
      [label]="getMaskedNumber(card)"
      [color]="'secondary'"
      [control]="getFormControl('cards')"
      [value]="card"
    ></kt-checkbox>
  </fieldset>

  <div class="d-flex justify-content-center">
    <button class="ks-btn-md ks-btn-outline-neutral ks-mr-10" (click)="onCancel()">Cancel</button>
    <button class="ks-btn-md ks-btn-primary" (click)="onContinue()">Continue</button>
  </div>
</div>
